import React from 'react';

export function DecisionCard({ title = 'Análise', pros = [], cons = [], recommendation = null }) {
  return (
    <div style={{ margin: '10px 0 14px', padding: '14px 16px', background: 'rgba(6,14,40,0.55)', border: '1px solid rgba(56,189,248,0.12)', borderRadius: 12, fontFamily: 'inherit' }}>
      <span style={{ fontSize: 9.5, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(56,189,248,0.55)', display: 'block', marginBottom: 12 }}>
        {title}
      </span>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: recommendation ? 12 : 0 }}>
        {/* Pros */}
        <div style={{ background: 'rgba(16,185,129,0.05)', border: '1px solid rgba(16,185,129,0.16)', borderRadius: 8, padding: '10px 12px' }}>
          <div style={{ fontSize: 10, color: '#10b981', fontWeight: 600, letterSpacing: '.04em', marginBottom: 8 }}>✓ PRÓS</div>
          {pros.map((p, i) => (
            <div key={i} style={{ fontSize: 12, color: 'rgba(220,228,255,0.72)', lineHeight: 1.45, marginBottom: i < pros.length - 1 ? 5 : 0 }}>
              · {p}
            </div>
          ))}
        </div>

        {/* Cons */}
        <div style={{ background: 'rgba(239,68,68,0.05)', border: '1px solid rgba(239,68,68,0.14)', borderRadius: 8, padding: '10px 12px' }}>
          <div style={{ fontSize: 10, color: '#ef4444', fontWeight: 600, letterSpacing: '.04em', marginBottom: 8 }}>✗ CONTRAS</div>
          {cons.map((c, i) => (
            <div key={i} style={{ fontSize: 12, color: 'rgba(220,228,255,0.72)', lineHeight: 1.45, marginBottom: i < cons.length - 1 ? 5 : 0 }}>
              · {c}
            </div>
          ))}
        </div>
      </div>

      {/* Recommendation */}
      {recommendation && (
        <div style={{ background: 'rgba(129,140,248,0.07)', border: '1px solid rgba(129,140,248,0.2)', borderRadius: 8, padding: '9px 12px' }}>
          <span style={{ fontSize: 10, color: '#818cf8', fontWeight: 600, letterSpacing: '.04em' }}>🏆 RECOMENDAÇÃO · </span>
          <span style={{ fontSize: 12, color: 'rgba(220,228,255,0.75)' }}>{recommendation}</span>
        </div>
      )}
    </div>
  );
}
